<template xmlns:v-slot="http://www.w3.org/1999/XSL/Transform">
  <v-dialog
    v-model="show"
    max-width="1200"
    :fullscreen="this.$vuetify.breakpoint.xs"
  >
    <v-card>
      <v-row align="center" class="pa-5 ma-0">
        <v-col>
          <div class="text-left display-1">
            Transacties
          </div>
        </v-col>
        <v-spacer></v-spacer>
        <v-col class="text-right">
          <v-btn icon @click="show = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-divider></v-divider>
      <v-window v-model="window" class="elevation-0" :show-arrows="false">
        <v-window-item>
          <v-data-table
            :hide-default-header="this.$vuetify.breakpoint.xs"
            class="pa-5"
            :loading="this.$store.getters['transactions/loading']"
            :headers="headers"
            :server-items-length="
              this.$store.getters['transactions/totalAmountTransactions']
            "
            :footer-props="{
              'items-per-page-options': [10, 20, 30, 40, 50]
            }"
            :items-per-page="10"
            :items="this.$store.getters['transactions/transactions']"
            @update:options="optionsUpdate"
          >
            <template v-slot:item.datetime="{ item }">
              <div>
                {{ item.datetime | time }}
              </div>
              <div class="font-weight-light ">
                {{ item.datetime | date) }}
              </div>
            </template>
            <template v-slot:item.article_amount="{ item }">
              <a
                v-if="item.products.length > 0"
                @click="productOnClick(item)"
                class="text-center"
                >{{ countArticles(item.products) }}
                {{
                  countArticles(item.products) === 1 ? "Product" : "Producten"
                }}</a
              >
              <div v-else>___</div>
            </template>
            <template v-slot:item.total_price_3decimals="{ item }">
              {{ (item.total_price_3decimals / 1000) | currency }}
            </template>
          </v-data-table>
        </v-window-item>
        <v-window-item>
          <div style="overflow-y: scroll; max-height: 450px" class="pa-5">
            <v-row>
              <v-col cols="12" md="6">
                <div class="mb-5 font-weight-bold">Transactie</div>
                <!--                <v-row v-for="item in headers">-->
                <!--                  <v-col cols="6">-->
                <!--                    <div class="font-weight-light">{{ item.text }}:</div>-->
                <!--                  </v-col>-->
                <!--                  <v-col v-if="item.value === 'total_price_3decimals'">-->
                <!--                    {{ (selectedTransaction[item.value] / 1000) | currency }}-->
                <!--                  </v-col>-->
                <!--                  <v-col v-else-if="item.value === 'article_amount'">-->
                <!--                    {{ countArticles(selectedTransaction.products) }}-->
                <!--                  </v-col>-->
                <!--                  <v-col v-else-if="item.value === 'datetime'">-->
                <!--                    {{ selectedTransaction[item.value] | datetime }}-->
                <!--                  </v-col>-->
                <!--                  <v-col v-else>-->
                <!--                    {{ selectedTransaction[item.value] }}-->
                <!--                  </v-col>-->
                <!--                </v-row>-->
              </v-col>
              <v-col cols="12" md="6">
                <div class="mb-5 font-weight-bold">Product(en)</div>
                <v-list>
                  <!--                  <div v-for="product in selectedTransaction.products">-->
                  <!--                    <v-list-item class="px-0" two-line>-->
                  <!--                      <div class="mr-4 font-weight-light">-->
                  <!--                        {{ product.quantity }}x-->
                  <!--                      </div>-->
                  <!--                      <v-list-item-content>-->
                  <!--                        <v-list-item-title>{{-->
                  <!--                          product.name-->
                  <!--                        }}</v-list-item-title>-->
                  <!--                        <v-list-item-subtitle>-->
                  <!--                          {{ (product.price_3decimals / 1000) | currency }}-->
                  <!--                        </v-list-item-subtitle>-->
                  <!--                      </v-list-item-content>-->
                  <!--                    </v-list-item>-->
                  <!--                    <v-divider></v-divider>-->
                  <!--                  </div>-->
                </v-list>
              </v-col>
            </v-row>
          </div>
          <div>
            <v-divider></v-divider>
            <div class="pa-5">
              <v-btn icon @click="window = 0">
                <v-icon>mdi-arrow-left</v-icon>
              </v-btn>
            </div>
          </div>
        </v-window-item>
      </v-window>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: "TransactionsDialog",
  props: ["value"],

  data() {
    return {
      headers: [
        {
          text: "Datum en tijd",
          align: "left",
          value: "datetime"
        },
        { text: "Bonnummer", value: "receipt" },
        { text: "Aantal Artikellen", value: "article_amount", sortable: false },
        { text: "Bedrag", value: "total_price_3decimals" }
      ],
      window: 0,
      selectedTransaction: { products: [] }
    };
  },
  computed: {
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit("input", value);
      }
    }
  },
  methods: {
    productOnClick(item) {
      this.selectedTransaction = item;
      this.window = 1;
    },
    optionsUpdate(e) {
      this.$store.commit("transactions/loading", true);
      this.$store.dispatch("transactions/transactions", e);
    },
    countArticles(products) {
      if (!products) return 0;
      let count = 0;
      for (let i = 0; i < products.length; i++) {
        count += products[i].quantity;
      }
      return count;
    }
  }
};
</script>

<style scoped></style>
